import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface QualityFormData {
  damage_kg: number;
  compensation_kg: number;
}

interface QualityAdjustmentFormProps {
  data: QualityFormData;
  onChange: (data: QualityFormData) => void;
}

export function QualityAdjustmentForm({
  data,
  onChange,
}: QualityAdjustmentFormProps) {
  const handleDamageChange = (value: string) => {
    const numValue = parseFloat(value) || 0;
    onChange({
      ...data,
      damage_kg: Math.max(0, numValue),
    });
  };

  const handleCompensationChange = (value: string) => {
    const numValue = parseFloat(value) || 0;
    onChange({
      ...data,
      compensation_kg: Math.max(0, numValue),
    });
  };

  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="damage_kg">Damage (KG)</Label>
        <Input
          id="damage_kg"
          type="number"
          step="0.01"
          min="0"
          value={data.damage_kg || ''}
          onChange={(e) => handleDamageChange(e.target.value)}
          placeholder="Enter damage amount"
        />
        <p className="text-xs text-muted-foreground">
          The total amount of damaged goods identified during quality inspection
        </p>
      </div>

      <div className="space-y-2">
        <Label htmlFor="quality_compensation">Compensation (KG)</Label>
        <Input
          id="quality_compensation"
          type="number"
          step="0.01"
          min="0"
          value={data.compensation_kg || ''}
          onChange={(e) => handleCompensationChange(e.target.value)}
          placeholder="Enter compensation amount"
        />
        <p className="text-xs text-muted-foreground">
          The compensation amount to be deducted from payment. This value is used to calculate the net payable.
        </p>
      </div>

      <div className="p-4 bg-muted border border-border rounded-lg">
        <p className="text-sm text-muted-foreground">
          <strong>Note:</strong> Changes to compensation will affect the net payable amount calculation 
          (Net Payable = Warehouse Received - Compensation)
        </p>
      </div>
    </div>
  );
}
